import request from "@/utils/request";

// 列表(主数据列表)
export function loadInventoryInfoListDataApi(data) {
  return request({
    url: "web/inventoryInfo/listData",
    method: "post",
    data,
  });
}

// 导出(主数据列表)
export function loadInventoryInfoExportDataApi(data) {
  return request({
    url: "web/inventoryInfo/exportData",
    method: "post",
    data,
  });
}

// 根据条件分页查询
export function listDataPageByConditionApi(data) {
  return request({
    url: "web/inventoryInfo/listDataPageByCondition",
    method: "post",
    data,
  });
}

// 查询物料在市场的备用库存数量
export function loadSpareInventoryDataApi(data) {
  return request({
    url: "web/inventoryInfo/loadSpareInventoryData",
    method: "post",
    data,
  });
}
